import PropTypes from 'prop-types'
import classNames from 'classnames'

import FAQs from '../../faqs'

import { useBreakpoint } from '../../../../hooks/breakpoint'

const Header = ({ title, items, ...attrs }) => {
  const breakpoint = useBreakpoint()

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-10',
      'pb-10',
      'md:pt-20',
      'md:pb-20',
      'md:bg-white'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <FAQs
        title={title}
        items={items}
        className={
          classNames([
            'block',
            'mx-auto',
            'w-full',
            'md:w-3/4'
          ])
        }
        titleAttrs={{
          size: breakpoint.mdAndUp ? 'seven' : 'five',
          className: classNames([
            'text-center',
            'mb-8'
          ])
        }}
      />
    </div>
  </section >
}

Header.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array
}
export default Header
